import type { GetRequestOptions } from "app/services/fetchService";
import { DefaultFetchService } from "app/services/fetchService";

import type { OnboardingAgentSuggestedQuestionsResponse } from "./onboardingAgentNudge.types";

const fetchService = DefaultFetchService.getInstance();

const ONBOARDING_AGENT_SUGGESTED_QUESTIONS_API_URL = "/api/onboarding/agent/suggested-questions";

export const onboardingAgentNudgeApiService = {
    getSuggestedQuestions(options?: Readonly<GetRequestOptions>): Promise<OnboardingAgentSuggestedQuestionsResponse> {
        return fetchService.get<OnboardingAgentSuggestedQuestionsResponse>(
            ONBOARDING_AGENT_SUGGESTED_QUESTIONS_API_URL,
            null,
            options,
        );
    },
};
